import React from "react";
import Header from "components/Header/Header";
import Frame from "components/Frame/Frame";
import Footer from "components/Footer/Footer";

const FrameService = () => {
    return (
        <div className='overlay'>
            <Header />
            <Frame />
            <Footer />
        </div>
    );
};

export default FrameService;

